import placeholderImage from '../assets/imageMissing.png';
export default function errorImage(e) {
  e.target.src = placeholderImage;
}
